import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { JTBDTourData } from './model';

export const JTBD_FEATURE_KEY = 'jtbd';

export interface JTBDTourState {
  currentJtbdEvent: string;
  currentModuleId: string;
  currentStepId: string;
  currentStepIndex: number;
  currentTooltipId: string;
  currentTooltipIndex: number;
  currentTourId: string;
  isJTBDTourActive: boolean;
  isSchemesEmpty: boolean;
  jtbdDataFromFirebase: JTBDTourData[];
  jtbdEvents: string[];
}

export const initialJTBDTourState: JTBDTourState = {
  currentJtbdEvent: '',
  currentModuleId: '',
  currentStepId: '',
  currentStepIndex: 0,
  currentTooltipId: '',
  currentTooltipIndex: 0,
  currentTourId: '',
  isJTBDTourActive: false,
  isSchemesEmpty: false,
  jtbdDataFromFirebase: [],
  jtbdEvents: [],
};

export const jtbdTourSlice = createSlice({
  name: JTBD_FEATURE_KEY,
  initialState: initialJTBDTourState,
  reducers: {
    updateCurrentJTBDEvent(state, action: PayloadAction<string>) {
      state.currentJtbdEvent = action.payload;
    },
    updateCurrentModuleId(state, action: PayloadAction<string>) {
      state.currentModuleId = action.payload;
    },
    updateCurrentStepId(state, action: PayloadAction<string>) {
      state.currentStepId = action.payload;
    },
    updateCurrentStepIndex(state, action: PayloadAction<number>) {
      state.currentStepIndex = action.payload;
    },
    updateCurrentTooltipId(state, action: PayloadAction<string>) {
      state.currentTooltipId = action.payload;
    },
    updateCurrentTooltipIndex(state, action: PayloadAction<number>) {
      state.currentTooltipIndex = action.payload;
    },
    updateCurrentTourId(state, action: PayloadAction<string>) {
      state.currentTourId = action.payload;
    },
    updateIsJTBDTourActive(state, action: PayloadAction<boolean>) {
      state.isJTBDTourActive = action.payload;
    },
    updateIsSchemesEmpty(state, action: PayloadAction<boolean>) {
      state.isSchemesEmpty = action.payload;
    },
    updateJTBDDataFromFirebase(state, action: PayloadAction<JTBDTourData[]>) {
      state.jtbdDataFromFirebase = action.payload;
    },
    updateJTBDEvents(state, action: PayloadAction<string[]>) {
      state.jtbdEvents = action.payload;
    },
  },
});

export const {
  updateCurrentJTBDEvent,
  updateCurrentModuleId,
  updateCurrentStepId,
  updateCurrentStepIndex,
  updateCurrentTooltipId,
  updateCurrentTooltipIndex,
  updateCurrentTourId,
  updateIsJTBDTourActive,
  updateIsSchemesEmpty,
  updateJTBDDataFromFirebase,
  updateJTBDEvents,
} = jtbdTourSlice.actions;

export const getJTBDTourSliceState = (rootState: RootState): JTBDTourState =>
  rootState[JTBD_FEATURE_KEY];

export const getCurrentJTBDEvent = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentJtbdEvent
);

export const getCurrentModuleId = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentModuleId
);

export const getCurrentStepId = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentStepId
);

export const getCurrentStepIndex = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentStepIndex
);

export const getCurrentTooltipId = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentTooltipId
);

export const getCurrentTooltipIndex = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentTooltipIndex
);

export const getCurrentTourId = createSelector(
  getJTBDTourSliceState,
  (state) => state.currentTourId
);

export const getIsJTBDTourActive = createSelector(
  getJTBDTourSliceState,
  (state) => state.isJTBDTourActive
);

export const getIsSchemesEmpty = createSelector(
  getJTBDTourSliceState,
  (state) => state.isSchemesEmpty
);

export const getJTBDDataFromFirebase = createSelector(
  getJTBDTourSliceState,
  (state) => state.jtbdDataFromFirebase
);

export const getJTBDEvents = createSelector(
  getJTBDTourSliceState,
  (state) => state.jtbdEvents
);
